import { render, staticRenderFns } from "./VSelect.vue?vue&type=template&id=5552e1fa&scoped=true"
import script from "./VSelect.vue?vue&type=script&lang=js"
export * from "./VSelect.vue?vue&type=script&lang=js"
import style0 from "./VSelect.vue?vue&type=style&index=0&id=5552e1fa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5552e1fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5552e1fa')) {
      api.createRecord('5552e1fa', component.options)
    } else {
      api.reload('5552e1fa', component.options)
    }
    module.hot.accept("./VSelect.vue?vue&type=template&id=5552e1fa&scoped=true", function () {
      api.rerender('5552e1fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/volta/VSelect.vue"
export default component.exports